import { InjectionToken } from '@angular/core';

/**
 * A map of translations.
 */
export interface TranslationMap {
  [key: string]: string;
}

/**
 * Configuration for app translations.
 */
export interface TranslateConfig {
  /**
   * The name of the application (or applications) for which to load translations.
   *
   * A single string fetches that one app's keys (the common case). An **array** fetches each app
   * with a SEPARATE single-app request and merges the results client-side — used by the landing
   * app, which needs its own chrome keys (`landing`) plus the booking wizard's (`web-traveler`).
   * Each request carries exactly one real app name; a composite/comma value is never sent to the
   * API, so a write path can never cross-tag live records (AM-4866).
   */
  readonly appName: string | readonly string[];
  /**
   * The address of the API that serves the translations.
   */
  readonly apiAddress: string;
  /**
   * Whether this app auto-registers the translation keys it renders back to the API
   * (POST /app_text). Defaults to `true` when omitted, so existing apps are unchanged.
   *
   * Set `false` for a read-only surface that must never author keys at runtime — e.g. the
   * prerendered landing app. Landing only ever reads translations; it never authors them.
   */
  readonly registerKeys?: boolean;
}

/**
 * Injection token for the translation configuration.
 */
export const TRANSLATE_CONFIG = new InjectionToken<TranslateConfig>('TRANSLATE_CONFIG');
